import { PlayerRequestType } from '@dtvgo/player-common-utils';
import { getParamValueFromUrl } from '@dtvgo/utils';

/* Ott-common */

/**
 * Return a true in case of manifest comes with the tokenization as true, otherwise returns false
 * @param {object} params - The manifest URL.
 * @param {string} params.manifestUrl - The manifest URL.
 * @returns {boolean} - Returns true if the manifest URL has tokenization as true else returns false
 */
function hasTokenization(_ref) {
  var manifestUrl = _ref.manifestUrl;
  if (!manifestUrl) return false;
  return getParamValueFromUrl(manifestUrl, 'tokenization') === 'true';
}

/**
 * Return the CDN tokenization config for player
 * @param {("cookie" | "header" | "queryParam")[]} tokenType - An array with the wanted token types
 * @returns {CDNTokenizationConfig} - The CDN tokenization config object
 */
function getCDNTokenizationConfig() {
  var tokenType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cdnToken;
  var useCookie = tokenType.includes('cookie');
  var useHeader = tokenType.includes('header');
  var useQueryParam = tokenType.includes('queryParam');

  /**
   * onRequest function to modify the request based on tokenType
   * @param {string} type - The type of player request
   * @param {Request} request - The request object
   * @returns {Request} - The modified request object
   */
  var onRequest = function onRequest(type, request) {
    if (type !== PlayerRequestType.MANIFEST && type !== PlayerRequestType.SEGMENT) return {};
    var modifiedRequest = {};
    if (useCookie) {
      modifiedRequest.allowCrossSiteCredentials = true;
    }
    if (useHeader && cdnToken) {
      modifiedRequest.headers = {
        hdntl: cdnToken
      };
    }
    if (useQueryParam && cdnToken) {
      var _request$uris;
      modifiedRequest.uris = (_request$uris = request.uris) === null || _request$uris === void 0 ? void 0 : _request$uris.map(function (uri) {
        var url = new URL(uri);
        url.searchParams.set('hdntl', cdnToken);
        return url.toString();
      });
    }
    return modifiedRequest;
  };

  /**
   * onResponseReceived function to set the cdnToken from the response headers
   * @param {string} type - The type of player response
   * @param {Response} response - The response object
   */
  var onResponseReceived = function onResponseReceived(type, response) {
    if ((useHeader || useQueryParam) && response.headers.hdntl) cdnToken = response.headers.hdntl;
  };
  return {
    onRequest: onRequest,
    onResponseReceived: onResponseReceived
  };
}

/**
 * @typedef {object} Request
 * @property {string[]} uris
 * @property {import('./utils').ObjectOf<string>} headers
 * @property {string} method
 * @property {any} body
 * @property {boolean} allowCrossSiteCredentials
 */

/**
 * @typedef {object} Response
 * @property {string} uri
 * @property {string} originalUri
 * @property {number} [status]
 * @property {import('./utils').ObjectOf<string>} headers
 * @property {any} data
 */

/**
 * @typedef {object} CDNTokenizationConfig
 * @property {(request: Request) => Request} onRequest - A function to include CDN Token params in
 * the requests
 * @property {(response: Response) => void} onResponseReceived - A function to get CDN Token from
 * the responses
 */

export { getCDNTokenizationConfig, hasTokenization };
//# sourceMappingURL=tokenization.js.map
